export const hasAtLeastOneAssignedClient = (clients) => {
  return clients.length > 0;
};

export const hasAtLeastOneClientWithEngagementMilestones = (clients) => {
  return clients.some((c) => c.engagementMilestonesCount);
};
